export const FEATURE_NAME = '@zerops/zerops/feature/copy-code-dialog';
